import * as React from 'react';
import { openForgotPasswordModal } from '@/redux/modules/modal';
import { parseQueryParams, removeQueryParams, stringifyQuery } from '@/utils/queryParams';
import { useAppDispatch } from '@/redux/hooks';
import { useHistory, useLocation } from 'react-router-dom';

const ForgotPasswordAction = () => {
    const location = useLocation();
    const { push } = useHistory();
    const queryParams: any = React.useMemo(() => parseQueryParams(location.search), [location.search]);
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (queryParams.action === 'forgot') {
            const query = removeQueryParams(queryParams, ['action']);
            const stringified = stringifyQuery(query);
            const newLocation = location.pathname + stringified ? '?' + stringified : '';
            dispatch(openForgotPasswordModal());
            push(newLocation);
        }
    }, [dispatch, location, queryParams, push]);

    return null;
};

export default ForgotPasswordAction;
